import { render, staticRenderFns } from "./BeaconSetting.vue?vue&type=template&id=f513279e&"
import script from "./BeaconSetting.vue?vue&type=script&lang=js&"
export * from "./BeaconSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports